(() => {
  const getToggle = () => document.getElementById('EccomiSwitcherToggle');

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const toggle = getToggle();
      if (toggle) toggle.checked = false;
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ec-switcher__layer a');
    if (link) {
      const toggle = getToggle();
      if (toggle) toggle.checked = false;
    }
  });
})();
